
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"22","height":"18.34","viewBox":"0 0 23 21.58"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"id":"broom","d":"M23.25 2.279a.993.993 0 00-1.4 0l-4.67 4.668-.314-.307a4.907 4.907 0 00-6.3-.469 16.284 16.284 0 01-4.456 2.38l-2.032.6a4.935 4.935 0 00-3.051 2.582 4.873 4.873 0 00-.134 3.938 12.69 12.69 0 0011.869 7.9h.905a.991.991 0 00.566-.178 14.981 14.981 0 006.575-10A4.928 4.928 0 0019.385 9.1l-.785-.768 4.653-4.652a.993.993 0 00-.003-1.401zm-9.9 19.3h-.588a11.073 11.073 0 01-4.222-.83l.011-.006a11.314 11.314 0 004.264-3.724l.508-.746a.99.99 0 10-1.636-1.115l-.508.746a9.344 9.344 0 01-3.52 3.07l-1.231.626A10.541 10.541 0 013.9 17.078a11.392 11.392 0 004.289-2.611A.991.991 0 106.8 13.05a9.424 9.424 0 01-3.9 2.273c-.06-.132-.124-.262-.178-.4a2.848 2.848 0 01.083-2.333 2.962 2.962 0 011.827-1.546l2.031-.6a15.056 15.056 0 003.357-1.556l7.756 7.557a13.907 13.907 0 01-4.431 5.136zm5.507-8.509a12.171 12.171 0 01-.3 1.359l-6.838-6.648a2.951 2.951 0 011.72-.555 2.913 2.913 0 012.042.832L18 10.517a2.95 2.95 0 01.854 2.562z","transform":"translate(-.541 -1.99)","fill":"#727998"}})])
          )
        }
      }
    